import { CssBaseline, ThemeProvider } from "@mui/material";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// ClearFlow дизайн-система: токени + базові стилі (грузимо першими, до MUI).
import "@dms/ui/styles.css";
import "./mobile.css";

import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { theme } from "./theme";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Кореневий елемент #root не знайдено");
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
